"use client";

import { type ReactNode, useState } from "react";
import { DragContext } from "./DragContext";

interface DragContextProviderProps {
	children: ReactNode;
}

export function DragContextProvider({ children }: DragContextProviderProps) {
	const [isDragging, setIsDragging] = useState(false);

	return (
		<DragContext.Provider value={{ isDragging, setIsDragging }}>{children}</DragContext.Provider>
	);
}
